var _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCandles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 10217",
    style: {
      mixBlendMode: "overlay"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Green candle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    y: 38.5703,
    width: 3.9034,
    height: 10.7344,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M1.95166 35.6426L1.95166 59.063",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_2",
    x: 7.80664,
    y: 34.667,
    width: 3.9034,
    height: 6.34303,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_2",
    d: "M9.7583 31.7393L9.7583 48.3287",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_3",
    x: 15.6135,
    y: 23.4453,
    width: 3.9034,
    height: 6.34303,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_3",
    d: "M17.5652 20.5176L17.5652 37.107",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_4",
    x: 39.0342,
    y: 40.5225,
    width: 3.9034,
    height: 6.34303,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_4",
    d: "M40.9858 37.5947L40.9858 54.1842",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_5",
    x: 46.8408,
    y: 40.5225,
    width: 3.9034,
    height: 2.43963,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_5",
    d: "M48.7925 37.5947L48.7925 54.1842",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_6",
    x: 54.6477,
    y: 27.3477,
    width: 3.9034,
    height: 8.29473,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_6",
    d: "M56.5994 26.3721L56.5994 42.9615",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Green candle_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26_7",
    x: 62.4543,
    y: 18.5654,
    width: 3.9034,
    height: 6.34303,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44_7",
    d: "M64.406 1L64.406 32.2272",
    stroke: "white",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandles);
export default __webpack_public_path__ + "static/media/candles.4fb228b4ddaa056d8a9fd677408eb5f9.svg";
export { ForwardRef as ReactComponent };